var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircledCheckIcon = function SvgCircledCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2458",
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0Zm0 22.154C6.404 22.154 1.846 17.596 1.846 12S6.404 1.846 12 1.846 22.154 6.404 22.154 12 17.596 22.154 12 22.154Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2458",
    d: "M18.133 6.675a.917.917 0 0 0-1.298.115l-7.073 8.418-2.614-2.902a.922.922 0 1 0-1.373 1.234l3.323 3.693a.918.918 0 0 0 .687.305h.017a.944.944 0 0 0 .692-.328l7.754-9.231a.93.93 0 0 0-.115-1.304Z"
  })));
};
export default SvgCircledCheckIcon;